import request from './axios'


export function AxiosGetHome(_path, _data) {
    return new Promise((resolve, reject) => {
        request({
            url: "account/api"+_path,
            method: 'get',
            data: _data,
            params: {
                ..._data,
                time: new Date().getTime()
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}